<template>
  <div class="app-container content-information">
    <div class="ccui-navigation">
      <el-button
        size="mini"
        type="primary-icon-medium"
        icon="icon-ccui-return"
        @click="handleBack"
        >返回
      </el-button>
      <div class="ccui-navigation-divider" />
      <!-- 面包屑 -->
      <el-breadcrumb
        class="ccui-navigation-crumbs-container"
        separator-class="el-icon-arrow-right"
      >
        <el-breadcrumb-item :to="{ path: firstPath }"
          >{{ appName }}
        </el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{ path: '/applicationSettings/userManagement' }"
          >应用设置
        </el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{ path: '/applicationSettings/roleManagement' }"
          >权限管理
        </el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{ path: '/applicationSettings/roleManagement' }"
          >角色管理
        </el-breadcrumb-item>
        <el-breadcrumb-item
          >权限维护
          <span class="ccui-curr-crumb" style="margin-left: 10px">
            {{ $route.query.roleName }}</span
          >
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="el-main el-power-main ccui-app-container-detail">
      <div class="ccui-search-wrapper ccui-clearfix">
        <div class="ccui-tab-wrapper fl">
          <el-button type="table-top-active" size="mini">角色权限</el-button>
        </div>
      </div>

      <div
        class="multifunctional-table-wrapper powerManageMaintain"
        ref="thatTable"
      >
        <check-table
          :checkboxData="checkboxData"
          @childrenSelected="childrenSelected"
          :disabledFlag="disabled"
          :powerList="powerList"
          :makeList="makeList"
        >
        </check-table>
      </div>
    </div>

    <el-bottom-guide v-if="!disabled">
      <ul class="ccui-bottom-button">
        <li>
          <el-button type="bottom" icon="icon-ccui-return" @click="handleBack"
            >返回
          </el-button>
        </li>
        <li class="ccui-bottom-guide-divider"></li>
        <li>
          <el-button type="bottom" icon="icon-ccui-save" @click="updateRoleMenu"
            >保存
          </el-button>
        </li>
        <li>
          <el-button type="bottom" icon="icon-ccui-cancel" @click="resetHandle"
            >取消
          </el-button>
        </li>
      </ul>
    </el-bottom-guide>
  </div>
</template>

<script>
// getRoleMenu,
import { getRoleMenuList, editRoleMenu } from "../api/powerManage";
import getMenuaa from "../mixins/getMenu.js";
import CheckTable from "../components/checkboxTable2";
import { ishasAgentId } from "@/basa/utils/index";
// import store from "@/config/store";
export default {
  name: "powerManageMaintain",
  components: {
    CheckTable
  },
  mixins: [getMenuaa],
  data() {
    return {
      submitFlag: false,
      appName: JSON.parse(sessionStorage.userDetal).agentName,
      funWidth: "auto",
      roleName: "",
      powerlist: [],
      menu: [],
      disabled: false,
      roleType: "",
      checked1: false,
      checkboxData1: [
        {
          moduleName: "功能点1",
          isShow: 1,
          sons: [
            {
              moduleName: "功能点1.1",
              isShow: 2,
              sons: [
                {
                  moduleName: "功能点1.1.1",
                  isShow: 3,
                  sons: []
                },
                {
                  moduleName: "功能点1.1.2",
                  isShow: 3,
                  sons: []
                }
              ]
            }
          ]
        },
        {
          moduleName: "功能点2",
          isShow: 1,
          sons: [
            {
              moduleName: "功能点2.1",
              isShow: 2,
              sons: []
            }
          ]
        },
        {
          moduleName: "功能点3",
          isShow: 1,
          sons: []
        },
        {
          moduleName: "功能点4",
          isShow: 1,
          sons: [
            {
              moduleName: "功能点4.1",
              isShow: 2,
              sons: []
            }
          ]
        }
      ],
      checkboxData: [],
      params: null,
      powerList: [
        {
          name: "个人",
          value: "1"
        },
        {
          name: "部门",
          value: "2"
        },
        {
          name: "指定部门",
          value: "3"
        },
        {
          name: "单位",
          value: "4"
        },
        {
          name: "本级及下级单位",
          value: "5"
        }
      ],
      makeList: [
        {
          name: "新增",
          isChecked: false,
          value: "1"
        },
        {
          name: "删除",
          isChecked: false,
          value: "2"
        },
        {
          name: "编辑",
          isChecked: false,
          value: "3"
        },
        {
          name: "查看",
          isChecked: false,
          value: "4"
        }
      ],
      jurisdctionBO: []
    };
  },
  mounted() {
    console.log(this.$store.getters, "-------");
    this.funWidth = this.$refs["thatTable"].offsetWidth - 2 - 200;
    //this.getRoleName()
    this.getRoleMenu();
    this.roleType = this.$route.query.roleType;
    if (this.roleType == "0" || this.roleType == "1") {
      this.disabled = true;
    }
  },
  methods: {
    childrenSelected(val) {
      console.log("已选择", val);
      this.params = val;
      this.getJurisdctionBO(val);
    },
    getRoleMenu() {
      let obj = {
        roleId: this.$route.query.roleId,
        roleType: Number(this.$route.query.roleType),
        isShowPageLoading: true
      };
      getRoleMenuList(obj).then(res => {
        if (res.data.code == "0") {
          this.params = [...res.data.data];
          res.data.data = res.data.data.filter(v => v.isShow != 0);
          res.data.data.forEach(i => {
            i.sons = i.sons.filter(p => !(p.isShow === 0));
            i.sons.forEach(j => {
              j.sons = j.sons.filter(p => !(p.isShow === 0));
            });
          });
          console.log(res.data.data, 66666666666666);
          res.data.data.forEach((item, idx) => {
            if (item.sons.length > 0) {
              if (this.$store.getters.getOrgId != 104577) {
                if (item.funcName == "极简询价") {
                  res.data.data.splice(idx, 1);
                }
                if (item.funcName == "财务管理") {
                  console.log(item, "++++++++++");
                  item.sons.forEach(i => {
                    if (i.funcName == "财务收款管理") {
                      console.log("1");
                      item.sons.splice(item.sons.indexOf(i), 1);
                    }
                  });
                }
                // delete item.sons[1];
              } else {
                console.log("777777777");
              }
              // }
              item.sons.forEach(item1 => {
                if (item1.sons.length > 0) {
                  if (this.$store.getters.getOrgId != 104577) {
                    if (item1.funcName === "收款管理") {
                      item1.sons.forEach(k => {
                        if (k.funcName === "采购单位付款单查询") {
                          console.log(item1.sons, "item1.sons.indexOf(i)");
                          item1.sons.splice(item1.sons.indexOf(k), 1);
                        }
                      });
                    }
                  }

                  this.$set(item1, "powerValue", []);
                  item1.dataType = item1.dataType ? item1.dataType : 0;
                  item1.powerValue.push(item1.dataType.toString());
                  item1.sons.forEach(item2 => {
                    this.getMenuItem(item2);
                    // item2.isUseable == 1
                    //     ? (item2.selected = true)
                    //     : (item2.selected = false);
                    // this.$set(item2, "powerValue", []);
                    // item2.powerValue.push(item2.dataType.toString());
                    // if(item2.dataType == 0){
                    //   this.$set(item2, "checkSelected", true);
                    // }
                    // item2.menuOperationBos.forEach(item3 => {
                    //   item2.operationCodeBos.forEach((item4, index4) => {
                    //     if (item4.id == item3.optId) {
                    //       this.$set(item4, "selected", true);
                    //     }
                    //   });
                    // });
                  });
                  if (item1.sons.some(i => i.selected == true)) {
                    item1.selected = true;
                    item1.isUseable = 1;
                  } else {
                    item1.selected = false;
                    item1.isUseable = 0;
                  }
                  if (item.sons.some(i => i.selected == true)) {
                    item.selected = true;
                    item.isUseable = 1;
                  } else {
                    item.selected = false;
                    item.isUseable = 0;
                  }
                } else {
                  this.getMenuItem(item1);
                  this.$set(item1, "isLeaf", true);
                  // item1.isUseable == 1
                  //     ? (item1.selected = true)
                  //     : (item1.selected = false);
                  // this.$set(item1, "powerValue", []);
                  // item1.powerValue.push(item1.dataType.toString());
                  // if(item1.dataType == 0){
                  //   this.$set(item1, "checkSelected", true);
                  // }
                  // item1.menuOperationBos.forEach(item3 => {
                  //   item1.operationCodeBos.forEach((item4, index4) => {
                  //     if (item4.id == item3.optId) {
                  //       this.$set(item4, "selected", true);
                  //     }
                  //   });
                  // });
                  if (item.sons.some(i => i.selected == true)) {
                    item.selected = true;
                    item.isUseable = 1;
                  } else {
                    item.selected = false;
                    item.isUseable = 0;
                  }
                }
              });
            } else {
              this.getMenuItem(item);
              this.$set(item, "isLeaf", true);
              // item.isUseable == 1
              //     ? (item.selected = true)
              //     : (item.selected = false);
              // this.$set(item, "powerValue", []);
              // item.powerValue.push(item.dataType.toString());
              // if(item.dataType == 0){
              //   this.$set(item, "checkSelected", true);
              // }
              // item.menuOperationBos.forEach(item3 => {
              //   item.operationCodeBos.forEach((item4, index4) => {
              //     if (item4.id == item3.optId) {
              //       this.$set(item4, "selected", true);
              //     }
              //   });
              // });
            }
          });
          this.getJurisdctionBO(res.data.data);
          this.checkboxData = res.data.data;
        }
      });
    },
    getMenuItem(item) {
      item.isUseable == 1 ? (item.selected = true) : (item.selected = false);
      this.$set(item, "powerValue", []);
      this.$set(item, "isSave", false);
      item.dataType = item.dataType ? item.dataType : 0;
      item.powerValue.push(item.dataType.toString());
      if (item.dataType == 0) {
        this.$set(item, "checkSelected", true);
      }
      // item.menuOperationBos.forEach(item3 => {
      //   item.operationCodeBos.forEach((item4, index4) => {
      //     if (item4.id == item3.optId) {
      //       this.$set(item4, "selected", true);
      //     }
      //   });
      // });
    },
    getJurisdctionBO(params) {
      this.jurisdctionBO = [];
      params.forEach(item => {
        if (item.sons.length > 0) {
          item.sons.forEach(item1 => {
            if (item1.sons.length > 0) {
              item1.sons.forEach(item2 => {
                if (item2.isShow != 0) {
                  this.jurisdctionBO.push({
                    menuId: item2.funcId,
                    funcName: item2.funcName,
                    dataType: item2.dataType,
                    dataDeptIds: item2.dataType == "3" ? item2.dataDeptIds : "",
                    isSelect: item2.dataType == 0 ? false : true,
                    OperationBos: []
                  });
                  this.jurisdctionBO.forEach(item3 => {
                    if (item3.menuId == item2.funcId) {
                      item2.menuOperationBos.forEach(item4 => {
                        item3.OperationBos.push({
                          optId: item4.optId,
                          menuId: item2.funcId
                        });
                      });
                    }
                  });
                }
              });
            } else {
              item.sons.forEach(item2 => {
                if (item2.isShow != 0) {
                  this.jurisdctionBO.push({
                    menuId: item2.funcId,
                    dataType: item2.dataType,
                    dataDeptIds: item2.dataType == "3" ? item2.dataDeptIds : "",
                    isSelect: item2.dataType == 0 ? false : true,
                    OperationBos: []
                  });
                  this.jurisdctionBO.forEach(item3 => {
                    if (item3.menuId == item2.funcId) {
                      // this.$set(item3,'OperationBos',[])
                      item2.menuOperationBos.forEach(item4 => {
                        item3.OperationBos.push({
                          optId: item4.optId,
                          menuId: item2.funcId
                        });
                      });
                    }
                  });
                }
              });
            }
          });
        } else {
          if (item.isShow != 0) {
            this.jurisdctionBO.push({
              menuId: item.funcId,
              dataType: item.dataType,
              dataDeptIds: item.dataType == "3" ? item.dataDeptIds : "",
              isSelect: item.dataType == 0 ? false : true,
              OperationBos: []
            });
            this.jurisdctionBO.forEach(item3 => {
              if (item3.menuId == item.funcId) {
                // this.$set(item3,'OperationBos',[])
                item.menuOperationBos.forEach(item4 => {
                  item3.OperationBos.push({
                    optId: item4.optId,
                    menuId: item.funcId
                  });
                });
              }
            });
          }
        }
      });
    },
    formatData(data) {
      data.map(res => {
        res.checked = true;
        if (res.sons && res.sons.length > 0) {
          this.formatData(res.sons);
        }
        return res;
      });
    },
    handleBack() {
      // 返回
      this.$router.push({ path: "/applicationSettings/roleManagement" });
    },
    updateRoleMenu() {
      // 保存
      editRoleMenu({
        roleId: this.$route.query.roleId,
        infos: this.params,
        jurisdctionBO: this.jurisdctionBO,
        isShowLoading: true
      }).then(res => {
        this.submitFlag = true;
        this.$message({
          message: this.tips.empowerSuccessTip,
          type: "success",
          duration: 0,
          ccuiCustom: true,
          showClose: true,
          offset: document.body.clientHeight / 2 - 21
        });
        // this.$store.dispatch("setMenu",[])
        this.getRoleMenu();
        // location.reload();
      });
      // .catch(erro => {
      //     console.log(erro)
      // })
    },
    resetHandle() {
      // 取消
      this.getRoleMenu();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.submitFlag === true) {
      for (var key in this.$vnode.parent.componentInstance.cache) {
        delete this.$vnode.parent.componentInstance.cache[
          ishasAgentId(to.path, key)
        ];
      }
    }
    next();
  },
  computed: {
    firstPath() {
      return this.$store.getters.addRouters[0].path;
    }
  }
};
</script>
<style lang="scss" scoped>
//@import "../../../config/styles/variables";

.app-container {
  background: none;
  padding: 0;
}

.powerManageMaintain {
  padding-top: 20px;
  //width: 1200px;
}

.el-power-main {
  min-height: calc(100vh - 260px);
}

.app-container {
  min-height: auto;
}

/deep/ .el-table td div {
  line-height: 27px;
}
.multifunctional-table-wrapper {
  /deep/.el-table--border {
    border-right: none !important;
  }
  .el-table--group {
    border-right: none !important;
  }
}
</style>
